module.exports = __webpack_public_path__ + "static/img/origins.a6ee91b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/origins.png
// module id = 276
// module chunks = 1